import * as esriLoader from 'esri-loader'
import loggingService from '@/services/util/loggingService'
const appConfig = require('../../static/config/config.json')

export var EsriMap
export var InfoTemplate
export var ArcGISDynamicMapServiceLayer
export var ArcGISTiledMapServiceLayer
export var LayerList
export var esriId
export var ServerInfo
export var esriConfig
export var esriRequest
export var SpatialReference
export var OverviewMap
export var HomeButton
export var Scalebar
export var Measurement
export var AttributeInspector
export var AttachmentEditor
export var Units
export var webMercatorUtils
export var Point
export var Extent
export var Navigation
export var Draw
export var IdentifyTask
export var IdentifyParameters
export var GeometryService
export var ProjectParameters
export var registry
export var TitlePane
export var ContentPane
export var BorderContainer
export var TabContainer
export var Toolbar
export var HorizontalSlider
export var Button
export var DropDownButton
export var DropDownMenu
export var ComboButton
export var ToggleButton
export var TextBox
export var CheckBox
export var MenuItem
export var Tooltip
export var TooltipDialog
export var dijitPopup
export var Popup
export var arrayUtils
export var Moveable
export var dom
export var domConstruct
export var domStyle
export var on
export var query
export var parser
export var domRea
export var LayerDrawingOptions
export var SimpleLineSymbol
export var SimpleFillSymbol
export var SimpleMarkerSymbol
export var SimpleRenderer
export var Color
export var Search
export var Query
export var QueryTask
export var all
export var Circle
export var PrintTask
export var PrintParameters
export var PrintTemplate
export var FeatureLayer
export var rendererJsonUtils
export var Graphic
export var scaleUtils
export var Geoprocessor
export var domClass
export var PopupTemplate
export var domUtils
export var GraphicsLayer
var loadEsriCalled = false
var loadPromise

var isDebug = false

function internalloadEsri () {
    loggingService.log(isDebug, 'esriLoadService', 'internalloadEsri')

    if (!loadPromise) {
        loggingService.log(isDebug, 'esriLoadService', 'loading esri modules')
        loadPromise = new Promise((resolve, reject) => {
            esriLoader.dojoRequire([
                'esri/map',
                'esri/InfoTemplate',
                'esri/layers/ArcGISDynamicMapServiceLayer',
                'esri/layers/ArcGISTiledMapServiceLayer',
                'esri/dijit/LayerList',
                'esri/IdentityManager',
                'esri/ServerInfo',
                'esri/config',
                'esri/request',
                'esri/SpatialReference',
                'esri/dijit/OverviewMap',
                'esri/dijit/HomeButton',
                'esri/dijit/Scalebar',
                'esri/dijit/Measurement',
                'esri/dijit/AttributeInspector',
                'esri/dijit/editing/AttachmentEditor',
                'esri/units',
                'esri/geometry/webMercatorUtils',
                'esri/geometry/Point',
                'esri/toolbars/navigation',
                'esri/toolbars/draw',
                'esri/tasks/IdentifyTask',
                'esri/tasks/IdentifyParameters',
                'esri/tasks/GeometryService',
                'esri/tasks/ProjectParameters',
                'dijit/registry',
                'dijit/TitlePane',
                'dijit/layout/ContentPane',
                'dijit/layout/BorderContainer',
                'dijit/layout/TabContainer',
                'dijit/Toolbar',
                'dijit/form/HorizontalSlider',
                'dijit/form/Button',
                'dijit/form/DropDownButton',
                'dijit/DropDownMenu',
                'dijit/form/ComboButton',
                'dijit/form/ToggleButton',
                'dijit/form/TextBox',
                'dijit/form/CheckBox',
                'dijit/MenuItem',
                'dijit/Tooltip',
                'dijit/TooltipDialog',
                'dijit/popup',
                'esri/dijit/Popup',
                'dojo/_base/array',
                'dojo/dnd/Moveable',
                'dojo/dom',
                'dojo/dom-construct',
                'dojo/dom-style',
                'dojo/on',
                'dojo/query',
                'dojo/parser',
                'dojo/domReady!',
                'esri/layers/LayerDrawingOptions',
                'esri/symbols/SimpleLineSymbol',
                'esri/symbols/SimpleFillSymbol',
                'esri/symbols/SimpleMarkerSymbol',
                'esri/renderers/SimpleRenderer',
                'esri/Color',
                'esri/dijit/Search',
                'esri/tasks/query',
                'esri/tasks/QueryTask',
                'esri/geometry/Extent',
                'dojo/promise/all',
                'esri/geometry/Circle',
                'esri/tasks/PrintTask',
                'esri/tasks/PrintParameters',
                'esri/tasks/PrintTemplate',
                'esri/layers/FeatureLayer',
                'esri/renderers/jsonUtils',
                'esri/graphic',
                'esri/geometry/scaleUtils',
                'esri/tasks/Geoprocessor',
                'dojo/dom-class',
                'esri/dijit/PopupTemplate',
                'esri/domUtils',
                'esri/layers/GraphicsLayer'
            ]
            ,
            (EsriMap_, InfoTemplate_, ArcGISDynamicMapServiceLayer_, ArcGISTiledMapServiceLayer_, LayerList_, esriId_, ServerInfo_, esriConfig_, esriRequest_, SpatialReference_, OverviewMap_, HomeButton_, Scalebar_,
                Measurement_, AttributeInspector_, AttachmentEditor_, Units_, webMercatorUtils_, Point_, Navigation_, Draw_, IdentifyTask_, IdentifyParameters_, GeometryService_, ProjectParameters_, registry_,
                TitlePane_, ContentPane_, BorderContainer_, TabContainer_, Toolbar_, HorizontalSlider_, Button_, DropDownButton_, DropDownMenu_, ComboButton_, ToggleButton_, TextBox_, CheckBox_, MenuItem_, Tooltip_, TooltipDialog_, dijitPopup_, Popup_, arrayUtils_, Moveable_, dom_,
                domConstruct_, domStyle_, on_, query_, parser_, domReady_, LayerDrawingOptions_, SimpleLineSymbol_, SimpleFillSymbol_, SimpleMarkerSymbol_, SimpleRenderer_, Color_, Search_, Query_, QueryTask_, Extent_, all_, Circle_, PrintTask_, PrintParameters_, PrintTemplate_, FeatureLayer_, rendererJsonUtils_,
                Graphic_, scaleUtils_, Geoprocessor_, domClass_, PopupTemplate_, domUtils_, GraphicsLayer_) => {
                EsriMap = EsriMap_
                InfoTemplate = InfoTemplate_
                ArcGISDynamicMapServiceLayer = ArcGISDynamicMapServiceLayer_
                ArcGISTiledMapServiceLayer = ArcGISTiledMapServiceLayer_
                LayerList = LayerList_
                esriId = esriId_
                ServerInfo = ServerInfo_
                esriConfig = esriConfig_
                esriRequest = esriRequest_
                SpatialReference = SpatialReference_
                OverviewMap = OverviewMap_
                HomeButton = HomeButton_
                Scalebar = Scalebar_
                Measurement = Measurement_
                AttributeInspector = AttributeInspector_
                AttachmentEditor = AttachmentEditor_
                Units = Units_
                webMercatorUtils = webMercatorUtils_
                Point = Point_
                Navigation = Navigation_
                Draw = Draw_
                IdentifyTask = IdentifyTask_
                IdentifyParameters = IdentifyParameters_
                GeometryService = GeometryService_
                ProjectParameters = ProjectParameters_
                registry = registry_
                TitlePane = TitlePane_
                ContentPane = ContentPane_
                BorderContainer = BorderContainer_
                TabContainer = TabContainer_
                Toolbar = Toolbar_
                HorizontalSlider = HorizontalSlider_
                Button = Button_
                DropDownButton = DropDownButton_
                DropDownMenu = DropDownMenu_
                ComboButton = ComboButton_
                ToggleButton = ToggleButton_
                TextBox = TextBox_
                CheckBox = CheckBox_
                MenuItem = MenuItem_
                Tooltip = Tooltip_
                TooltipDialog = TooltipDialog_
                dijitPopup = dijitPopup_
                Popup = Popup_
                arrayUtils = arrayUtils_
                Moveable = Moveable_
                dom = dom_
                domConstruct = domConstruct_
                domStyle = domStyle_
                on = on_
                query = query_
                parser = parser_
                domRea = domReady_
                LayerDrawingOptions = LayerDrawingOptions_
                SimpleLineSymbol = SimpleLineSymbol_
                SimpleFillSymbol = SimpleFillSymbol_
                SimpleMarkerSymbol = SimpleMarkerSymbol_
                SimpleRenderer = SimpleRenderer_
                Color = Color_
                Search = Search_
                Query = Query_
                QueryTask = QueryTask_
                Extent = Extent_
                all = all_
                Circle = Circle_
                PrintTask = PrintTask_
                PrintParameters = PrintParameters_
                PrintTemplate = PrintTemplate_
                FeatureLayer = FeatureLayer_
                rendererJsonUtils = rendererJsonUtils_
                Graphic = Graphic_
                scaleUtils = scaleUtils_
                Geoprocessor = Geoprocessor_
                domClass = domClass_
                PopupTemplate = PopupTemplate_
                domUtils = domUtils_
                GraphicsLayer = GraphicsLayer_

                esriConfig.defaults.io.corsEnabledServers.push(appConfig.Map_Token_Server)
                esriConfig.defaults.io.corsEnabledServers.push(appConfig.gis_url + appConfig.Map_PrintServiceEndpoint)
                resolve(true)
            })
        })
    } else {
        loggingService.log(isDebug, 'esriLoadService', 'returning existing promise')
    }
    return loadPromise
}

function continueLoad () {
    return new Promise((resolve, reject) => {
        if (!esriLoader.isLoaded() && !loadEsriCalled) {
            loggingService.log(isDebug, 'esriLoadService', 'esriLoadService.continueLoad 1')
            loadEsriCalled = true
            esriLoader.bootstrap((err) => {
                loggingService.log(isDebug, 'esriLoadService', 'esriLoadService.continueLoad 3')
                if (err) {
                    console.error(err)
                }
                resolve(internalloadEsri())// once it's loaded, create the map
            }, {
                        // use a specific version instead of latest 4.x
                url: 'https://js.arcgis.com/3.24/'
            }
                )
        } else {
            loggingService.log(isDebug, 'esriLoadService', 'esriLoadService.continueLoad 2')
            resolve(internalloadEsri())// ArcGIS API is already loaded, just create the map
        }
    })
}

export function loadEsri (source) {
    loggingService.log(isDebug, 'esriLoadService', 'loadEsri, source: ' + source)
    loggingService.log(isDebug, 'esriLoadService', 'loadEsri, loadPromise: ' + loadPromise)
    loggingService.log(isDebug, 'esriLoadService', 'loadEsri, loadEsriCalled: ' + loadEsriCalled)

    return new Promise((resolve, reject) => {
        if (!loadPromise) {
            if (loadEsriCalled) {
                //running into a race condition here. add a timeout for that initial check
                setTimeout(function () {
                    resolve(continueLoad())
                }, 500)
            } else {
                resolve(continueLoad())
            }
        } else {
            // loggingService.log(isDebug, 'esriLoadService', 'returning existing esri load promise')
            resolve(loadPromise)
        }
    })
}

export function destroyComponentById (source, id) {
    if (registry) {
        var control = registry.byId(id)
        destroyComponent(source, id, control)
    }
}

export function destroyComponent (source, id, control) {
    if (control == null) {
        loggingService.log(isDebug, 'esriLoadService', source + ' - destroyComponent - ' + id + ' - could not be found')
    } else {
        if (typeof control.destroy === 'function') {
            control.destroy()
            loggingService.log(isDebug, 'esriLoadService', source + ' - destroyComponent - destroyed - ' + id)
        } else {
            loggingService.log(isDebug, 'esriLoadService', source + ' - destroyComponent - No destroy method found! - ' + id)
        }
    }
}

export default {
    EsriMap: EsriMap,
    InfoTemplate: InfoTemplate,
    ArcGISDynamicMapServiceLayer: ArcGISDynamicMapServiceLayer,
    ArcGISTiledMapServiceLayer: ArcGISTiledMapServiceLayer,
    LayerList: LayerList,
    esriId: esriId,
    ServerInfo: ServerInfo,
    esriConfig: esriConfig,
    esriRequest: esriRequest,
    SpatialReference: SpatialReference,
    OverviewMap: OverviewMap,
    HomeButton: HomeButton,
    Scalebar: Scalebar,
    Measurement: Measurement,
    AttributeInspector: AttributeInspector,
    AttachmentEditor: AttachmentEditor,
    Units: Units,
    webMercatorUtils: webMercatorUtils,
    Point: Point,
    Extent: Extent,
    Navigation: Navigation,
    Draw: Draw,
    IdentifyTask: IdentifyTask,
    IdentifyParameters: IdentifyParameters,
    GeometryService: GeometryService,
    ProjectParameters: ProjectParameters,
    registry: registry,
    TitlePane: TitlePane,
    ContentPane: ContentPane,
    BorderContainer: BorderContainer,
    TabContainer: TabContainer,
    Toolbar: Toolbar,
    HorizontalSlider: HorizontalSlider,
    Button: Button,
    DropDownButton: DropDownButton,
    DropDownMenu: DropDownMenu,
    ComboButton: ComboButton,
    ToggleButton: ToggleButton,
    TextBox: TextBox,
    CheckBox: CheckBox,
    MenuItem: MenuItem,
    Tooltip: Tooltip,
    TooltipDialog: TooltipDialog,
    dijitPopup: dijitPopup,
    Popup: Popup,
    arrayUtils: arrayUtils,
    Moveable: Moveable,
    dom: dom,
    domConstruct: domConstruct,
    domStyle: domStyle,
    on: on,
    query: query,
    parser: parser,
    domRea: domRea,
    loadEsri: loadEsri,
    domClass: domClass,
    Geoprocessor: Geoprocessor,
    PopupTemplate: PopupTemplate,
    domUtils: domUtils,
    GraphicsLayer: GraphicsLayer
}



// WEBPACK FOOTER //
// ./src/services/esriLoadService.js